/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gallery-filters[_ngcontent-%COMP%]{display:-webkit-box;display:flex}.gallery-filters__category[_ngcontent-%COMP%]{-webkit-box-flex:0;flex:0 0 auto;position:relative}.gallery-filters__category-select[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;z-index:2}.gallery-filters__category-selection[_ngcontent-%COMP%]{background-color:#d7e0ea;border:1px solid #96a8c0;border-right:0;-webkit-box-flex:1;flex:1 1 auto;border-radius:4px 0 0 4px}.gallery-filters__query[_ngcontent-%COMP%]{border-radius:0 4px 4px 0}"];
export { styles as styles };
